import React, { useEffect, useState, Suspense, useContext, useCallback, } from "react";
import { Link } from "react-router-dom";
import { Rating } from 'primereact/rating';
import { TostMsg } from "../../../../App";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import {
  SendFeedback, ShowFeedback
} from "./Services/SendUsFeedbackService";
import { GetFAQList, GetMasterSystemAlert } from "../../../../Services/Global-Services/GlobalServices";
const ComponentLoader = React.lazy(() =>
  import("../../../../Shared/Sidebar/ComponentLoader")
);
const defaultImage = "/images/placeholder_profile.png";
const SendUsFeedback = () => {
  const [feedbackDataList, setFeedbackDataList] = useState([]);
  const [faqListes, setFAQListes] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [loader, setLoading] = useState(false);
  const [ratevalue, setRateValue] = useState(0);
  const [text, setText] = useState("");
  const [rating, setRating] = useState(0);
  const [totalReview, SetTotalReview] = useState(null);
  const [averageReview, SetAverageReview] = useState(null);
  const [sharedReview, SetSharedReview] = useState(null);
  const toster = useContext(TostMsg);
  let userDetails = JSON.parse(localStorage.getItem("User") || '');
  const [activeFAQIndex, setActiveFAQIndex] = useState(null);

  useEffect(() => {
    GetFeedback();
    GetMasterSystemAlertList()
    GetFAQes()
  }, [])

  useEffect(() => {
    if (feedbackDataList?.orgEmpFeedbackListResponse?.length > 0) {
      setRateValue(feedbackDataList?.orgEmpFeedbackListResponse[0]?.Ratings);
      setText(feedbackDataList?.orgEmpFeedbackListResponse[0]?.Feedback);
    }
  }, [feedbackDataList])

  async function GetFeedback() {
    setLoading(true)
    const body = {
      loggedInEmpId: userDetails?.EmpId
    };
    try {
      let response = await ShowFeedback(body);
      setFeedbackDataList(response?.Data);
      setLoading(false);
    } catch (error) {
      toster.current.error(ERROR_LIST?.SendUsFeedBack);
      setLoading(false);
    }
  }

  async function SaveFeedbacks() {
    setLoading(true)
    const body = {
      Feedback: text,
      Ratings: ratevalue
    };
    try {
      const response = await SendFeedback(body);
      if (response) {
        GetMasterSystemAlertList("feedback_added", 0);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc)
      } else if (msg?.Name == 'feedback_description') {
        SetSharedReview(msg?.Desc);
      } else if (msg?.Name == 'review_count') {
        SetTotalReview(msg?.Desc);
      } else if (msg?.Name == 'overall_rating_count') {
        SetAverageReview(msg?.Desc);
      };
    })
  }, [])

  const handleChanges = (newRating) => {
    setRating(newRating);
  };

  async function GetFAQes() {
    setLoading(true);
    const body = {
      FAQTypeId: 103,
    };
    try {
      const response = await GetFAQList(body);
      setFAQListes(response?.Data);
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setLoading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []); 

  return (
    <div >
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn" >
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
          </div>
          <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
          </Link>
          <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
          </a>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row g-3">
          <div className="">
            <div className="col-md-12">
              <div className="card">
                <img src="images/org-img/leave/popup-backimg.png" style={{ position: "absolute", right: "0", width: "100%", opacity: "0.4" }} />
                <div className="card-body" style={{ padding: "1rem" }}>
                  <div className="block-header">
                    <div className="rightfeed-form center1">
                      <h2>Share Your Feedback</h2>
                      <p>{sharedReview}</p>
                      <div className="give-rate">
                        <span className="block-heading">Rate :</span>
                        <Rating value={ratevalue} onChange={(e) => setRateValue(e.value)} cancel={false} chan />
                      </div>
                      <div className="form-group d-flex flex-column">
                        <textarea className="form-control" rows="6" placeholder="Share your thoughts" onChange={(event) => setText(event?.target?.value)} value={text}></textarea>
                        <button className={text.length < 3 ? 'button.sendfeed-disable btn btn-disabled  mt-3' : 'sendfeed' }  type="button" onClick={() => SaveFeedbacks()} disabled={text.length < 3}>Submit</button>
                      </div>
                    </div>
                  </div>
                  <div className="latest-feedreview">
                    <div className="me-auto" style={{ padding: "1rem 0rem 0rem 0rem", textAlign: "center" }}>
                      <h2 className="font-w600 mb-0 d-block">Reviews & Feedback</h2>
                    </div>
                    <div className="col-xl-12 mt-4">
                      <div className="row justify-content-center">
                        <div className="col-xl-4">
                          <div className="total-review">
                            <strong>{feedbackDataList?.Totalfeedbackcount}</strong>
                            <h4>Total Review</h4>
                            <p>{totalReview}</p>
                          </div>
                        </div>
                        <div className="col-xl-4">
                          <div className="total-review">
                            <strong>{feedbackDataList?.Overall_Ratings}</strong>
                            <h4>Average Review</h4>
                            <p>{averageReview}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="detail-review">
                        <div className="row g-2">
                          {feedbackDataList?.feedbackSummaries?.map((el) => (
                            <div className="col-xl-3">
                              <div className="cards">
                                <div className="imggrid">
                                  <img className="avatar" src={el?.CreatedByProfileImage || defaultImage}
                                    onError={handleImageError} />
                                  <span className="dark-inverted">{el?.CreatedByName}</span>
                                </div>
                                <span className="star-review d-block mb-2 mt-2 fs-16">
                                  <Rating value={el?.Ratings} cancel='' />
                                </span>
                                <p className="mb-0 d-xl-inline-block">{el?.Feedback}</p>
                              </div>
                            </div>
                          ))
                          }
                        </div>
                      </div>
                      <div className="me-auto mt-2" style={{ padding: "1rem 0rem 0rem 0rem", textAlign: "center" }}>
                        <h2 className="font-w600 mb-0">Frequently Asked Questions</h2>
                      </div>                      
                      <div className="col-xl-12 faqlist" >
                        <div className="accordion">
                          <div className="row" >
                            {faqListes?.map((el, index) => (
                            <div className="col-md-6" key={index}>
                             <div className="accordion-item">
                              <h2 className="accordion-header" id={`one1-${index}`}>
                              <button
                               className={`accordion-button ${activeFAQIndex === index ? '' : 'collapsed'}`}
                                type="button"
                                onClick={() => setActiveFAQIndex(prev => prev === index ? null : index)}
                                aria-expanded={activeFAQIndex === index}
                                aria-controls={`collapse1-${index}`}
                               >
                              {el.Question}
                              </button>
                              </h2>
                              <div
                              id={`collapse1-${index}`}
                              className={`accordion-collapse collapse ${activeFAQIndex === index ? 'show' : ''}`}
                              aria-labelledby={`one1-${index}`}
                               >
                            <div className="accordion-body">
                            <p>{el.Answer}</p>
                           </div>
                          </div>
                          </div>
                         </div>
                             ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="contact-manager">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">Contact Your Reporting Manager htmlFor Any Leave Clarifications</h5>
            </div>
            <div className="modal-body text-center">
              <form>
                <div className="form-group text-left">
                  <label>Repoting Manager</label>
                  <select className="default-select form-control wide mb-3">
                    <option selected disabled>Select reporting manager</option>
                    <option>Arun Mishra</option>
                    <option>Pragya Tiwari</option>
                    <option>Alisha Goyal</option>
                  </select></div>
                <div className="form-group text-left">
                  <label className="mt-3">Reason</label>
                  <textarea rows="4" cols="1" className="form-control"></textarea></div>
              </form>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-danger light" data-bs-dismiss="modal">Decline</button>
              <button type="button" className="btn btn-primary">Accept</button>
            </div>
          </div>
        </div>
      </div>
      {loader ? (
        <Suspense >
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  )
};

export default SendUsFeedback;